import _ from 'lodash'
import { useMutation } from '@apollo/client'
import { DocumentNode } from 'graphql'
import { notification } from 'antd'

import { BaseDownloadMessage } from '~/core/startDownload'

import createZipDownloadOrderDetails from './createZipDownloadOrderDetails'
import createInspectionZipDownloadOrderDetails from './createInspectionZipDownloadOrderDetails'

type CreateZipDownloadOrderDetailsData = {
    id: string
    jobStartDate: string
    jobCompleteDate: string
    name: string
    error: string
    url: string
}

function SalesOrderDownloadMessage(props: {
    orderName: string
    total: number
    mutation: DocumentNode
    notificationKey: string
}) {
    const [downloadMutation] = useMutation<{
        createZipDownloadOrderDetails: CreateZipDownloadOrderDetailsData
    }>(props.mutation)
    const { orderName, total, notificationKey } = props

    return (
        <BaseDownloadMessage
            total={total}
            openCompleteNotification
            notificationKey={notificationKey}
            fetchZip={async () => {
                const response = await downloadMutation({
                    variables: {
                        orderName,
                    },
                })

                return response?.data?.createZipDownloadOrderDetails?.url
            }}
        />
    )
}

export async function startSalesOrderZipDownload({
    orderName,
    total,
}: {
    orderName: string
    total: number
}) {
    const salesOrderNotificationKey = _.uniqueId('download-salesOrder-message')

    await notification.open({
        key: salesOrderNotificationKey,
        duration: null,
        description: (
            <SalesOrderDownloadMessage
                total={total}
                orderName={orderName}
                mutation={createZipDownloadOrderDetails}
                notificationKey={salesOrderNotificationKey}
            />
        ),
        message: 'Download files',
    })
}

function SalesOrderInspectionDownloadMessage(props: {
    id: string | undefined
    mutation: DocumentNode
    notificationKey?: string
}) {
    const [downloadMutation] = useMutation<{
        createZipDownloadOrderDetails: CreateZipDownloadOrderDetailsData
    }>(props.mutation)
    const { id, notificationKey } = props

    return (
        <BaseDownloadMessage
            openCompleteNotification
            notificationKey={notificationKey}
            fetchZip={async () => {
                const response = await downloadMutation({
                    variables: {
                        id,
                    },
                })

                return response?.data?.createZipDownloadOrderDetails?.url
            }}
        />
    )
}

export async function startSalesOrderInspectionZipDownload({
    id,
}: {
    id: string | undefined
}) {
    const salesOrderInspectionKey = _.uniqueId(
        'download-salesOrder-inspection-message',
    )

    return await notification.open({
        key: salesOrderInspectionKey,
        duration: null,
        description: (
            <SalesOrderInspectionDownloadMessage
                id={id}
                mutation={createInspectionZipDownloadOrderDetails}
                notificationKey={salesOrderInspectionKey}
            />
        ),
        message: 'Download files',
    })
}
